import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'
// import dash from './dashboardTools.js';
import dash from './dashboardTools.js'
import plotly from './plotlyTools.js'


import axios from "axios";
import $ from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js'
import './nlp/tabler.css';
import './nlp/imageclassify.css';
import bulk from './nlp/imageclassify.js';
import './panel.css';
// import './jquery-simple-upload.css';
// import '@kanety/jquery-simple-upload';

function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring( o ){ return typeof(o) == 'string';}
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function error( s ) {
    var err = $('<div role="alert" class="fade alert alert-danger show">').html(s);
	$('.maincontent').html('').append(err);
}


function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}

function fix(s) { return (s).toString().replace(/[^a-z0-9 \.@_\-]/ig, '').toLowerCase().replace(/ +/g, ' ').trim() }


var descriptor = {
	"labels": null,
	"dataset": null,
	"imageLayout": {
		"showLabels": true,
		"showDetails": true,
		"showControls": false
	},
	"detailLayout": {
		"policy": "doubleclick",
		"customDetail": null,
		"doubleSize": 2,
		"showLabels": true,
		"showDetails": true,
		// "showControls": true
	},
	"imageControls": {
		"redAdjust": true,
		"greenAdjust": true,
		"blueAdjust": false,
		"brigtnessAdjust": true
	},
	"gridLayout": {
		"imageZoom": 8,
		"itemsPerPage": 40,
		"filter": {
			"globalFilter": true,
			"keyFilter": true,
			"annotation": true
		},
		"toggleLabels": false,
		"toggleDetails": true,
		"toggleControls": true,
	},
	"userRole": {
		// "email": "marcelo@me.com",
		// "role": "nlp_an"
		"role": "admin",
	},
	// "classificationMode": true,
	"selectionMode": "multi",
	"blockEdit": true,
    "datasetMode": true,
}


var global = window.GlobalVars;
var tasks = null;
var project = null;
var datasetId = null;

var dashboardVisible = false;

var compare1 = null;
var compare2 = null;
function dashboard( gFilters, filters ) {
	if (!dashboardVisible) return;
	var db = $('#dashboard');
	db.html('').append($(`
			<div class="container-fluid">
			</div>
	`));

	var ncharts = 0;
	var chartRow = null;
	function addChartDiv() {
		if (!(ncharts % 2)) {
			chartRow = $('<div class="row">');
			db.find('.container-fluid').append(chartRow)
		}
		var divCont = $('<div class="ccol-sm col-6 chart-' + ncharts + '">')
		var div = $('<div class="dashboard-cell">')
		divCont.append(div);
		chartRow.append(divCont);
		ncharts++;
		return div;
	}

	console.log( 'FILTERS', filters, 'gFilters', gFilters )
	var ftmp = filters || [];
	var flist = [];
	for( let f of ftmp ) {
		flist.push( {
			key: f.key,
			label: f.key + ': ' + f.value,
			value: f.value,
		})
	}
	console.log( 'FLIST', flist )
	if( compare1 && !flist.find( f => f.key == compare1.key && f.value == compare1.value ) ) compare1 = null;
	if( compare2 && !flist.find( f => f.key == compare2.key && f.value == compare2.value ) ) compare2 = null;
	if( !compare1 ) {
		compare1 = flist.find( f => f.key == 'Model Run' );
	}
	if( compare1 && !compare2 ) {
		compare2 = flist.find( f => f.key == 'Project' ) || flist.find( f => f.key == 'Model Run' && f.value != compare1.value ) || null;
	}
	if( compare1 && compare2 && compare1.key == compare2.key && compare1.value == compare2.value ) compare2 = null;
	console.log( 'compare1', compare1, 'compare2', compare2 )

	var dparam = {datasetId:datasetId,filter:gFilters,compare1:compare1,compare2:compare2,datasetType:descriptor.datasetData.datasetType}
	var key = JSON.stringify(dparam);
	console.log( key )
	frm.loading('Loading Dashboard Data' );
	let qualityMetrics = null;
	let predictions = null;
	let allLabels = null;
	let cMatrix = null;
	let cMatrixLabels = null;
	console.log( 'dparam', dparam )
	window.post('dataset_dashboard', dparam, res => {
		console.log( 'dataset_dashboard', res )
		let data = res.data;
		predictions = data.predictions;
		qualityMetrics = data.qualityMetrics;
		allLabels = data.allLabels;
		cMatrix = data.cMatrix;
		cMatrixLabels = data.cMatrixLabels;
		
		window.qualityMetrics = qualityMetrics;
		window.predictions = predictions;
		window.allLabels = allLabels;
		// console.log( JSON.stringify(data, null, '\t') );
		frm.loadingOut();
		// return console.log( 'dash', res, qualityMetrics )
		draw();
	})


	
	function draw() {
		try {
			function num(v) { return typeof (v) == 'number' ? v : '-'; }
			function fix2(v) { return typeof (v) == 'number' ? v.toFixed(2) : '-'; }

			let tab = $('<table><tr><td id="compare1"><div class="imgcls-title">Model Run</div></td><td id="compare2"><div class="imgcls-title">GroundTruth</div></td></table>');
			db.find('.container-fluid').append(tab);

			let fcmp1 = flist.filter(f => (f.key == 'Model Run') && (
				(!compare2 || f.label != compare2.label)
			)).map(f => { return { label: f.label, value: f.label } });
			var c1 = frm.dropDown($('#compare1'), fcmp1, compare1.label, {
				placeholder: 'Select Model Run',
				width: 400
			}, function (v) {
				if (!v) return;
				if ((compare1 && compare1.label == v) || (compare2 && compare2.label == v)) return
				//  c1.setValue(compare1.label);
				compare1 = flist.find(f => f.label == v) || compare1;
				dashboard(gFilters, filters);
			})


			let fcmp2 = flist.filter(f => (f.key == 'Model Run' || f.key == 'Project') && f.label != compare1.label).map(f => { return { label: f.label, value: f.label } });
			var c2 = frm.dropDown($('#compare2'), fcmp2, compare2 && compare2.label, {
				placeholder: 'Select Ground Truth',
				width: 400
			}, function (v) {
				if (!v) return;
				if ((compare1 && compare1.label == v) || (compare2 && compare2.label == v)) {
					// c2.setOptions( fcmp2, compare2 && compare2.label );
					return;
				}
				//  c2.setValue(compare2 &&compare2.label );
				compare2 = flist.find(f => f.label == v) || compare2;
				dashboard(gFilters, filters);
			})

			console.log('compare1', compare1);

			// Predicton Label Count
			if (compare2) {
				var labMax = 1500;
				var llist = [];
				for (var l of allLabels) { llist.push({ name: l.label, count: [l.predictionCount || 0, l.groundtruthCount || 0] }) }
				llist.sort((a, b) => a.count > b.count ? -1 : 1)
				var tit = 'Label Distribution';
				llist.splice(labMax, 10000);

				// var cfg = {
				// 	container: addChartDiv(),
				// 	title: tit,
				// 	// max: 100,
				// 	format: ival,
				// 	formatTooltip: ival,
				// 	formatTick: ival,
				// 	paddingY: 30,
				// 	rotated: true,
				// 	// dataColor: function (c, d) { return lcolors[d.x % lcolors.length] },
				// 	// size:{height:500},
				// 	// basevalue:getVal,
				// 	// hideLegends: true,
				// 	hideY: true,
				// };
				var d = {
					"values": [],
					"xLabels": [],
					"yLabels": ["Prediction", "Ground Truth"]
				};
				console.log('LLIST', llist)
				for (var l of llist) {
					// lcolors.push( labelColor(l) );
					d.xLabels.push([l.name, '']);
					d.values.push(l.count)
				}

				console.log('d before', d)

				let xValuesArray = [];
				let xDataArray = [];
				let colorsArray = ['rgb(155, 92, 182)', 'rgb(52, 73, 94)', 'rgb(0, 255, 0)', 'rgb(255, 137, 0)', 'rgb(0,128,255)']

				if(Array.isArray(d.values[0])){
					for (let j in d.values[0]) {
						let row = [];
						for (let i in d.values) {
							row.push(d.values[i][j]);
						}
						xValuesArray.push(row);
					}
			
					for(let [index, xValue] of xValuesArray.entries()){
						let trace = {};
						trace = {
							values: xValue,
							name: d.yLabels[index],
							color: index == 0 ? colorsArray[0] : colorsArray[index],
							orientation: 'h',
						}
						xDataArray.push(trace)
					}
				}else{
					let trace = {};
					trace = {
						values: d.values,
						// name: 'bar1',
						color: colorsArray[0],
						orientation: 'h'
					}
					xDataArray.push(trace)
				}

				console.log('xdata', xDataArray)


				let data = {
					xData : xDataArray,
					showXlabels: false,
					yValues: d.xLabels.flat().filter( v => v > '' ),
					yLabel: d.yLabels,
					container : addChartDiv()[0]
				}

				console.log('dataa', data)
			
				let config = {
					chartTitle: tit,
					size: {
						height: '650',
						width: '400'
					},
					barmode: 'group',
				}

				plotly.drawBarChart(data, config)
				// dash.drawGraphBar(d, cfg);
			} else {
				var labMax = 1500;
				var llist = [];
				for (var l of predictions) { llist.push({ name: l.label, count: l.count }) }
				llist.sort((a, b) => a.count > b.count ? -1 : 1)
				var tit = 'Label Distribution';
				llist.splice(labMax, 10000);

				// var cfg = {
				// 	container: addChartDiv(),
				// 	title: tit,
				// 	// max: 100,
				// 	format: ival,
				// 	formatTooltip: ival,
				// 	formatTick: ival,
				// 	paddingY: 30,
				// 	rotated: true,
				// 	// dataColor: function (c, d) { return lcolors[d.x % lcolors.length] },
				// 	// size:{height:500},
				// 	// basevalue:getVal,
				// 	hideLegends: true,
				// 	hideY: true,
				// };
				var d = {
					"values": [],
					"xLabels": [],
					"yLabels": ["Prediction"]
				};
				for (var l of llist) {
					// lcolors.push( labelColor(l) );
					d.xLabels.push(l.name);
					d.values.push([l.count])
				}

				let xValuesArray2 = [];
				let xDataArray2 = [];

				if(Array.isArray(d.values[0])){
					for (let j in d.values[0]) {
						let row = [];
						for (let i in d.values) {
							row.push(d.values[i][j]);
						}
						xValuesArray2.push(row);
					}
			
					for(let xValue of xValuesArray2){
						let trace = {};
						trace = {
							values: xValue,
							// name: 'bar1',
							color: function (c, d) {
								let max = c < 0.5 ? 1 - c : c;
								// max *= 1.2;
			
								let r = Math.floor((1 - c) / max * 255).toString(16).padStart(2, 0);
								let g = Math.floor((c) / max * 255).toString(16).padStart(2, 0);
								let color = '#' + r + g + '00';
								// console.log( 'COLOR', d, color, max, (1-c)/max, (c)/max ) 
								return color; },
							orientation: 'h',
						}
						xDataArray2.push(trace)
					}
				}else{
					let trace = {};
					trace = {
						values: d.values,
						// name: 'bar1',
						color: function (c, d) {
								let max = c < 0.5 ? 1 - c : c;
								// max *= 1.2;
			
								let r = Math.floor((1 - c) / max * 255).toString(16).padStart(2, 0);
								let g = Math.floor((c) / max * 255).toString(16).padStart(2, 0);
								let color = '#' + r + g + '00';
								// console.log( 'COLOR', d, color, max, (1-c)/max, (c)/max ) 
								return color; },
						orientation: 'h'
					}
					xDataArray2.push(trace)
				}

				let data = {
					xData : xDataArray2,
					showXlabels: false,
					yValues: d.xLabels,
					yLabel: d.yLabels,
					container : addChartDiv()[0]
				}
			
				let config = {
					chartTitle: tit,
					size: {
						height: '650',
						width: '400'
					},
					// barmode: false,
					// dataColor : function (c, d) {  return lcolors[d % lcolors.length]; }
				}

				plotly.drawBarChart(data, config)
				// dash.drawGraphBar(d, cfg);
			}



			// Predicton Label Confidence
			var labMax = 15;
			var llist = [];
			for (var l of predictions) { llist.push({ name: l.label, count: l.confidence }) }
			llist.sort((a, b) => a.count > b.count ? -1 : 1)
			var tit = 'Average Prediction Label Confidence';
			if (llist.length > labMax) tit = 'Prediction Top Labels Confidence';
			llist.splice(labMax, 10000);

			// var cfg = {
			// 	container: addChartDiv(),
			// 	title: tit,
			// 	max: 1,
			// 	format: fix2,
			// 	formatTooltip: fix2,
			// 	formatTick: fix2,
			// 	paddingY: 30,
			// 	rotated: true,
			// 	dataColor: function (c, d) {
			// 		let max = d.value < 0.5 ? 1 - d.value : d.value;
			// 		// max *= 1.2;

			// 		let r = Math.floor((1 - d.value) / max * 255).toString(16).padStart(2, 0);
			// 		let g = Math.floor((d.value) / max * 255).toString(16).padStart(2, 0);
			// 		let color = '#' + r + g + '00';
			// 		// console.log( 'COLOR', d, color, max, (1-d.value)/max, (d.value)/max ) 
			// 		return color;
			// 		// return lcolors[d.x % lcolors.length] 
			// 		return '#ff0000';
			// 	},
			// 	// size:{height:500},
			// 	// basevalue:getVal,
			// 	hideLegends: true,
			// 	hideY: true,
			// };
			var d = {
				"values": [],
				"xLabels": [],
				"yLabels": ["Label count"]
			};
			for (var l of llist) {
				// lcolors.push( labelColor(l) );
				d.xLabels.push(l.name);
				d.values.push([l.count])
			}

			console.log('wip', d)

			let xValuesArray3 = [];
				let xDataArray3 = [];

				if(Array.isArray(d.values[0])){
					for (let j in d.values[0]) {
						let row = [];
						for (let i in d.values) {
							row.push(d.values[i][j]);
						}
						xValuesArray3.push(row);
					}
			
					for(let xValue of xValuesArray3){
						let trace = {};
						trace = {
							values: xValue,
							texttemplate: "%{x:.2f}",
							// name: 'bar1',
							color: function (c, d) {
								let max = c < 0.5 ? 1 - c : c;
								// max *= 1.2;
			
								let r = Math.floor((1 - c) / max * 255).toString(16).padStart(2, 0);
								let g = Math.floor((c) / max * 255).toString(16).padStart(2, 0);
								let color = '#' + r + g + '00';
								// console.log( 'COLOR', d, color, max, (1-c)/max, (c)/max ) 
								return color; },
							orientation: 'h',
						}
						xDataArray3.push(trace)
					}
				}else{
					let trace = {};
					trace = {
						values: d.values,
						texttemplate: "%{x:.2f}",
						// name: 'bar1',
						color: function (c, d) {
							let max = c < 0.5 ? 1 - c : c;
							// max *= 1.2;
		
							let r = Math.floor((1 - c) / max * 255).toString(16).padStart(2, 0);
							let g = Math.floor((c) / max * 255).toString(16).padStart(2, 0);
							let color = '#' + r + g + '00';
							// console.log( 'COLOR', d, color, max, (1-c)/max, (c)/max ) 
							return color; },
						orientation: 'h',
					}
					xDataArray3.push(trace)
				}

			let data2 = {
				xData : xDataArray3,
				showXlabels: false,
				yValues: d.xLabels.toReversed(),
				yLabel: d.yLabels,
				container : addChartDiv()[0]
			}

			console.log('dat2', data2)

		
			let config2 = {
				chartTitle: tit,
				size: {
					height: '650',
					width: '400'
				},
				// barmode: false,
				// dataColor : function (c, d) {  return lcolors[d % lcolors.length]; }
			}

			plotly.drawBarChart(data2, config2)
			// dash.drawGraphBar(d, cfg);

			async function cMatrixClick(x, y, z, data) {
				try {
					let configFilters = JSON.parse(atob(descriptor.config))[7];
					console.log('cMatrixClick', x, y, z, data )
					if( z == 0 ) return;
					let c1 = clone(compare1);
					let c2 = clone(compare2);
					c1.classification = x;
					c1.id = configFilters.find( f => f.value == c1.value ).id;

					c2.classification = y
					let compare = [c1, c2];
					if( c2.key == 'Project' ) {
						let res = await window.post('find_projects',{match:{id:{$in:descriptor.filterData['Project']}}})
						let prj = res.data.records.find( p => fix(p.name) == c2.value );
						c2.id = prj.id;
						c2.projectName = prj.name;
					}
					else c2.id = configFilters.find( f => f.value == c2.value ).id;
					console.log('compare', compare)
					let a = $('<a target="_blank">');
					a.attr('href', '?compare=' + btoa(JSON.stringify(compare)) + document.location.hash);
					document.body.append(a);
					a[0].click();
				}
				catch (e) { console.error(e) }
			}
			if( cMatrix && cMatrix.length ) {
				// Confusion Matrix Count
				var tit = 'Confusion Matrix (Count)';
	

				var cfg = {
					container: addChartDiv(),
					title: tit,
					cellClick: cMatrixClick,
				};
				var d = {
					zValues: [],
					xValues: cMatrixLabels,
					yValues: cMatrixLabels,
				}
				var cn = cMatrixLabels.length;
				for (var i = 0; i < cMatrix.length; i++) {
					if (!(i % cn)) {
						d.zValues.push([]);
					}
					d.zValues[Math.floor(i / cn)].push(cMatrix[i]);
				}
				//inver yValues and zValues
				let tmpz = d.zValues;
				let tmpy = d.yValues;
				d.zValues = [];
				d.yValues = [];
				for( let z of tmpz ) d.zValues.unshift(z);
				for( let y of tmpy ) d.yValues.unshift(y);
				console.log('CCCCCCCCCCCCC', d)

				// let colorscaleValue = [
				// 	[0, '#AED7FF'],
        		// 	[1, '#0080FF'],
				//   ];

				// let data = {
				// 	xData: d.xValues,
				// 	yData: d.yValues,
				// 	zData: d.zValues,
				// 	color: colorscaleValue,
				// 	container : addChartDiv()[0]
				// }

				// let config = {
				// 	chartTitle: tit,
				// 	size: {
				// 		height: '450',
				// 		width: '600'
				// 	},
				// }
				
				// plotly.drawHeatMapChart(data, config)
				plotly.drawHeatmap(d, cfg);
			}

			if( cMatrix && cMatrix.length ) {
				// Confusion Matrix Count
				var tit = 'Confusion Matrix (Percentage)';
	
				let ncMatrix = clone(cMatrix);
				console.log( 'ncMatrix', ncMatrix )
				let tots = [];
				let div = cMatrixLabels.length;
				for( let i = 0 ; i < ncMatrix.length ; i++ ) {
					let line = Math.floor(i/div);
					tots[line] = (tots[line] || 0) + ncMatrix[i];
				}
				for( let i = 0 ; i < ncMatrix.length ; i++ ) {
					let line = Math.floor(i/div);
					if( tots[line] ) ncMatrix[i] /= tots[line];
					ncMatrix[i] = ncMatrix[i].toFixed(2)
				}
				var cfg = {
					container: addChartDiv(),
					title: tit,
					cellClick: cMatrixClick,
				};
				var d = {
					zValues: [],
					xValues: cMatrixLabels,
					yValues: cMatrixLabels,
				}
				var cn = cMatrixLabels.length;
				for (var i = 0; i < ncMatrix.length; i++) {
					if (!(i % cn)) {
						d.zValues.push([]);
					}
					d.zValues[Math.floor(i / cn)].push(ncMatrix[i]);
				}
				//inver yValues and zValues
				let tmpz = d.zValues;
				let tmpy = d.yValues;
				d.zValues = [];
				d.yValues = [];
				for( let z of tmpz ) d.zValues.unshift(z);
				for( let y of tmpy ) d.yValues.unshift(y);
				console.log('CCCCCCCCCCCCC', d)

				
				// let colorscaleValue = [
				// 	[0, '#AED7FF'],
        		// 	[1, '#0080FF'],
				//   ];

				// let data = {
				// 	xData: d.xValues,
				// 	yData: d.yValues,
				// 	zData: d.zValues,
				// 	color: colorscaleValue,
				// 	container : addChartDiv()[0],
				// 	// texttemplate: "%{text:.2f}",
				// }

				// let config = {
				// 	chartTitle: tit,
				// 	size: {
				// 		height: '450',
				// 		width: '600'
				// 	},
				// }
				
				// plotly.drawHeatMapChart(data, config)
				plotly.drawHeatmap(d, cfg);
			}





			// Quality Metrics
			if (qualityMetrics && qualityMetrics.length) {
				var tableMetrix = $('<table class="mt-4">')
				tableMetrix.html('')
				db.append(tableMetrix);

				var desc = {
					title: 'Quality Metrics',
					columns: {
						name: 'Entity Name',
						TP: 'True Positive',
						TN: 'True Negative',
						FP: 'False Positive',
						FN: 'False Negative',
						p: 'Precision',
						r: 'Recall',
						f1: 'F1 Score',
						Kappa: 'Cohen\'s Kappa Score',
					},
					filter: false,
					search: false,
					sort: true,
					initialSort: 'name',
					initialSortDir: -1,
					pageSize: 10,
					noFilter: null,
					noSearch: null,
					noSort: null,
					centerCol: ['TP', 'TN', 'FP', 'FN', 'p', 'r', 'f1', 'Kappa'],
					formatCol: {
						TP: num,
						TN: num,
						FP: num,
						FN: num,
						p: fix2,
						r: fix2,
						f1: fix2,
						Kappa: fix2,
					},
					forceType: {
						TP: 1,
						TN: 1,
						FP: 1,
						FN: 1,
						p: 1,
						r: 1,
						f1: 1,
						Kappa: 1,
					},
				}
				var tabMetrics = tabler.table(tableMetrix, desc, null);
				for (let c of qualityMetrics) {
					tabMetrics.addRow(c)
				}
				tabMetrics.draw();
			}
		}
		catch (e) { console.error(e) }
	}
}


function DatasetItems(prop) {

    var global = window.GlobalVars;
    var tab;

	function dashFunc( gFilters, filters ) {
		console.log( 'DASHBOARD', filters );
		var dashBut = $('#dashboardButton');
		dashboardVisible = !dashboardVisible;
		if (dashboardVisible) {
			dashBut.html('Hide Dashboard');
			$('.imgcls-toolbar').css({ height: $('.imgcls-toolbar-commands').outerHeight() + 10 })
			$('.imgcls-toolbar').children().hide();
			$('.imgcls-browse').hide();
			$('.imgcls-toolbar-commands').show();
			$('#dashboard').show();
			dashboard( gFilters, filters )
			$(window).off('resize');
			$('#root').css({ height: 'auto', overflow: 'auto' })
		}
		else {
			$('.imgcls-toolbar').css({ height: '' })
			$('.imgcls-toolbar').children().show();
			$('.imgcls-browse').show();
			dashBut.html('Dashboard');
			$('#dashboard').hide();
			bulk.setResize()
			frm.loadingOut();
		}
	}

	async function start() {
		var cfg = window.getPageParams();
		datasetId = cfg.did || global.currentDatasetId;
		console.log( 'CFG', cfg, datasetId )
		descriptor.presignedConfig = {dataset:datasetId};
		var match = {datasetId:datasetId};

	
		// var match = {}
		descriptor.baseMatch = {type:'dataset','key':'itemId',match:match};
		$('.imgcls-toolbar-compare').hide();

		if (cfg.compare) {
			$('.mainnav').hide();
			$('.sidebar').hide();
			$('.maincontent').addClass('main_collapse')
			$('.top_switch').hide();
			setTimeout( function(){
				$('.maincontent').addClass('main_collapse')
			},1)

			let match = clone(descriptor.baseMatch.match)
			try {
				// let match = {};
				let cmp = JSON.parse(atob(cfg.compare));
				match.compare = [];
				let txtcomp = ['<table>'];
				let tit = [];
				// let
				let type = 'Prediction'; 
				for (let c of cmp) {
					console.log( 'CCC', c )
					txtcomp.push( '<tr>');
					if (c.key == 'Model Run') {
						txtcomp.push( '<td>'+type+'</td>');
						txtcomp.push( '<td>Model Run</td>' )
						txtcomp.push( '<td>' + c.id + '</td>' )
						txtcomp.push( '<td><b>' + c.classification + '</b></td>' )
						tit.push( c.classification );
						match.compare.push({
							prediction: {
								$elemMatch: {
									'0': c.id,
									'1.classification': c.classification
								}
							},
						})
					}
					else if (c.key == 'Project') {
						txtcomp.push( '<td>'+type+'</td>');
						txtcomp.push( '<td>Project</td>' )
						txtcomp.push( '<td>' + c.projectName + '</td>' )
						txtcomp.push( '<td><b>' + c.classification + '</b></td>' )
						tit.push( c.classification );
						match.compare.push({
							tasks: {
								$elemMatch: {
									project: c.id,
									classification: c.classification,
								}
							}
						})
					}
					type = 'Groundtruth';
					txtcomp.push( '</tr>');
					// alert(c.classification);
				}
				txtcomp.push( '</table>');
				console.log( 'ccc', JSON.stringify(match) )
				descriptor.baseMatch.match = match;
				descriptor.compareMode = true;
				document.title = tit.join(' / ')
				$('.imgcls-toolbar-compare').html(txtcomp.join('')).show()
				$('.imgcls-tool').hide();
			}
			catch (e) { console.error(e) }
		}
		console.log( 'baseMatch', descriptor.baseMatch );
		
		var getSize = 200000;
		var getSize = 200;
		descriptor.progressiveLoad = function( config, callback) {
			var start = config.start;
			var filter = config.filter;
			descriptor.loadFilter = filter;
			var end = config.end || 0;
			var limit = end > 0 ? end-start+1 : getSize;
			if (!filter) filter = {};
			if( !config.noLoading ) frm.loading('Loading Items');
			var inProgress = false;
			var exportProgress;
			// function showProcessing(progress) {
			// 	try {
			// 		if (!inProgress) {
			// 			inProgress = true;
			// 			frm.myAlert('Dataset processing', 'Dataset items are being processed, please wait.', 'Close', function () {
			// 				window.goPage('datasets')
			// 			});
			// 			exportProgress = new frm.progressBar($('.modal-body'));
			// 			// $('.modal-footer').hide();
			// 		}
			// 		exportProgress.set(progress)
			// 	}
			// 	catch (e) { console.error(e) }
			// 	setTimeout(getItems, 2000);
			// }
			function getItems(countProcessing) {
				var gmatch = clone(descriptor.baseMatch.match);
				if( Object.keys(filter).length ) gmatch.filter = filter;
				gmatch._start = start;
				gmatch._limit = limit;
				console.log( 'GMATCH', JSON.stringify(gmatch) )
				if( global.currentDataset.similarSearch ) {
					descriptor.similarSearch = global.currentDataset.similarSearch;
					gmatch = {findSimilar:global.currentDataset.similarSearch.result};
				}

				gmatch.countProcessing = countProcessing;

				window.post('dataset_items', gmatch, res => {
					// console.log( 'dataset_itemsssss', res.data )
					console.log('res datax', res);
					$('.count').remove();

					if ('progress' in res.data) {
						console.log('res dataxx', res);


						var status = $("<p>").text(`processing item: ${res.data.processing}`);
						status.addClass("count");
						status.css({
							textDecoration: "underline",
							color: "#4DA6FF",
							fontStyle: "italic"
						  });

						$('.processingStatus').append(status);

						setTimeout(() => {
							getItems(true);
						}, 3000);

						if(countProcessing) return;
					}
					// console.log('dataset_items', res);
					if (inProgress) frm.myAlertClose();
					
					descriptor.filterData = res.data.filter;
					if (res.data.start == 0) {
						descriptor.dataset = [];
						descriptor.dataset[res.data.count - 1] = null;
					}
					for (var i = 0; i < res.data.records.length; i++)
						descriptor.dataset[i + start] = res.data.records[i];
					if (descriptor.dataset.length == 0 && !Object.keys(filter).length && 
					( !res.data.filter || !res.data.filter.State || !res.data.filter.State.indexOf('Deleted') == -1 ) ) {
						frm.loadingOut();
						error('No documents found')
						return callback(res.data.records);
					}
					frm.loadingOut();
					callback(res.data.records);
				})
			}
			getItems();
		}
		descriptor.dashboardFunc = dashFunc;
		descriptor.configId = 'di-' + datasetId;
		descriptor.config = cfg.cfg || ((global.config || {})[descriptor.configId] || '');
		descriptor.configLock = cfg.cfg > '';
		descriptor.labels = [];
		if (window.hasPriv('admin', 'c_admin', 'd_super')) descriptor.blockEdit = false;
 
		function dsStart(){
			window.post('find_datasets', { match: match }, dres => {
				console.log('DATASET', dres.data)
				var datasetData = dres.data.records[0]
				if( 1 || datasetData.datasetType != 'Image' ) {
					descriptor.detailLayout.customDetail = async function( conf, prj, filter, sfilters ) {
						// alert( 'custom detail');

						let params = {
							ptype: 'datasetDetail',
							datasetType: datasetData.datasetType,
							datasetId: datasetData.datasetId,
							itemId: conf.itemId,
							fileId: null,
							project: prj || null,
						}
						// add model run to params if in filter
						let fmodel = sfilters.filter( f => f.key == "Model Run" ).map( f => f.id );
						if( fmodel.length ) {
							params.modelRun = fmodel;
						}
						// return console.log( 'params', params )

						if( !prj && datasetData.datasetType == 'Image' ) return false;
						if( prj ) {
							let res = await window.post('find_projects',{match:{id:prj}});
							let p = res.data.records[0];
							params.projectType = p.type; 
							params.projectName = p.name; 
							params.projectCompany = p.company; 
							res = await window.post('find_tasks', {match:{project:prj,itemId:conf.itemId}} );
							console.log( 'RES', res )
							params.fileId = res.data.records[0].fileId;
						}
						if( params.projectType == 'Bulk Image Classification' ) return false;

						let page = 'nlpAnnotations';
						if (params.projectType == 'Media Transcription') page = 'transcription';
						if (params.projectType == 'AmEx Audio Templete') page = 'transcription2';
						if (params.projectType == 'Code Switching') page = 'transcription3';
						else if (params.projectType == 'Pose Estimation') page = 'poseestimation';
						else if (params.projectType == 'Segmentation') page = 'segmentation';
						else if (params.projectType == 'Key Point') page = 'keypoint';
						if( conf.type.match(/(video|audio)/) && params.projectType != 'Classification' ) page = 'transcription';
						// console.log( 'cusom detail', params, conf, page )
						if( !filter["_filter.State"] ) filter["_filter.State"] = "processed";
						let sfilter = JSON.stringify(filter);
						if( !window.GlobalVars.itemList || window.GlobalVars.itemList.dataset != datasetData.datasetId  || window.GlobalVars.itemList.filter != sfilter) {
							let ddata = await window.post( 'dataset_items', {
								datasetId: datasetData.datasetId,
								// filter: { _project: 'itemId' }
								filter: filter
							});
							let ilist = ddata.data.records.map( d => d.itemId );
							let itemList = {
								dataset: datasetData.datasetId,
								list: ilist,
								filter: sfilter,
								idx: ilist.indexOf(conf.itemId),
							}
							window.GlobalVars.itemList = itemList;
							await window.saveSession();
						}
						else {
							window.GlobalVars.itemList.idx = window.GlobalVars.itemList.list.indexOf(conf.itemId)
							console.log( 'idx', window.GlobalVars.itemList.idx )
							await window.saveSession();
						}
						window.goPage(page, params)
						return true;
					}
				}
				// descriptor.gridLayout.rolloverPreview = datasetData.type != 'Image';
				descriptor.gridLayout.rolloverPreview = true;
				descriptor.gridLayout.toggleControls = datasetData.datasetType == 'Image';
				$('#pageTitle').find('span').html(datasetData.datasetName);
				descriptor.datasetData = datasetData;
				descriptor.dataset = [];
				var ftr = bulk.initFilter(descriptor);
				descriptor.progressiveLoad({
					start:0, 
					filter: ftr,
				}, () => {
					bulk.init(descriptor)
				})
			})
		}
		if( cfg.did ) {
			window.post('bookmark_access', {datasetId: cfg.did}, res => {
				dsStart();
			})
		}
		else dsStart();
		return null;
	}

	
    useEffect( function () {
		start();
		return function(){};
	} );

    return (
		<>
			<div fluid="md p-0" className="imgcls-main maincontent">
				<div className="processingStatus"></div>
				<div className="imgcls-toolbar hidden">
					<div className="imgcls-toolbar-commands"></div>
					<div className="imgcls-toolbar-filters imgcls-tool"></div>
					<div className="imgcls-toolbar-sort imgcls-tool"></div>
					<div className="imgcls-toolbar-project imgcls-tool"></div>
					<div className="imgcls-toolbar-compare hhidden"></div>
					<div className="imgcls-toolbar-tabs"></div>
					<div className="imgcls-toolbar-controls">
						<div className="imgcls-toolbar-sliders"></div>
						<div className="imgcls-toolbar-nav-placeholder"></div>
						<div className="imgcls-toolbar-nav"></div>
						<div className="imgcls-toolbar-buttons-placeholder"></div>
						<div className="imgcls-toolbar-buttons">
							<span className="selected-images"></span>
						</div>
					</div>
				</div>
				<div id="dashboard"></div>
				<div className="imgcls-browse">
				</div>
			</div>
		</>
    )
}

export default DatasetItems;
